import { Selectable } from "../../shared/core/ovs.core";
import { UnitType } from "./unit-type.model";

export class RoomFilter{
    public unitTypes: UnitType[];
    public nights: Selectable<number>[];
    //TODO: filter within days of search date
    //public withinDaysOfSelectedDate: number;
    public minPrice: number;
    public maxPrice: number;
    public name: string;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-availability-v2/room-filter.model.ts